import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import axios from "axios";
import { API_URL } from "../services/api";
// import bannerImage from "./shrokbannereditshop.png";
import curiousBanner from "./ecocuriousbannerrr.png";
import shrok from "./shrok.svg";

// original was ./FinalFrontEndBanner.gif';

function Home({ children }) {
  const [message, setMessage] = useState("");
  const [products, setProducts] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [businessesLoading, setBusinessesLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [statusType, setStatusType] = useState(""); // "success" or "error"

  // Featured product IDs - modify this array to include the IDs  want to show
  const featuredProductIds = [1711, 2734, 2824, 467, 2386, 1750, 1739, 2532];
  // TODO change 2221 to 2027
  // Testing business IDs - remove the testing ids
  const TestingBusinessIds = [1, 2, 3, 4, 5, 6, 7, 8];
  const excludedBusinessIds = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 21, 22,
  ];

  const prefetchShopData = async () => {
    try {
      // Prefetch initial shop products
      const shopResponse = await axios.get(`${API_URL}api/search/`, {
        params: {
          search: "",
          filter: "",
          category: "",
          page: 1,
          page_size: 20,
        },
        timeout: 30000,
      });

      // Cache the shop data
      const shopCacheData = {
        products: shopResponse.data.results || [],
        totalProducts: shopResponse.data.count || 0,
        nextPageUrl: shopResponse.data.next,
        prevPageUrl: shopResponse.data.previous,
        currentPage: 1,
        appliedFilters: {
          searchTerm: "",
          selectedFilter: "",
          selectedCategory: "",
        },
        timestamp: Date.now(),
      };

      localStorage.setItem(
        "shop_products_cache",
        JSON.stringify(shopCacheData)
      );
      //console.log('Shop data prefetched and cached');
    } catch (error) {
      console.error("Error prefetching shop data:", error);
    }
  };

  useEffect(() => {
    // Fetch home data
    const fetchHomeData = async () => {
      try {
        const { data } = await axios.get(`${API_URL}home/`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        setMessage(data.message);
      } catch (e) {
        console.error("Error fetching home data:", e);
      }
    };

    // Fetch featured products
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const productPromises = featuredProductIds.map((id) =>
          axios
            .get(`${API_URL}api/products/${id}/`, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => response.data)
            .catch((error) => {
              console.error(`Error fetching product ${id}:`, error);
              return null;
            })
        );

        const productResults = await Promise.all(productPromises);
        setProducts(
          productResults.filter((product) => product !== null).slice(0, 9)
        );
        setLoading(false);
      } catch (e) {
        console.error("Error fetching products:", e);
        setLoading(false);
      }
    };

    // Fetch businesses
    // Later, change this so specific businesses are exlcuded
    const fetchBusinesses = async () => {
      try {
        setBusinessesLoading(true);
        const { data } = await axios.get(`${API_URL}api/publicbusinesses/`, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        //  can filter businesses by IDs if needed
        // const filteredBusinesses = data.filter(business => featuredBusinessIds.includes(business.id));
        const filteredBusinesses = data.filter(
          (business) => !excludedBusinessIds.includes(business.id)
        );
        setBusinesses(filteredBusinesses);
        // setBusinesses(data);
        setBusinessesLoading(false);
      } catch (e) {
        console.error("Error fetching businesses:", e);
        setBusinessesLoading(false);
      }
    };

    fetchHomeData();
    fetchBusinesses();
    fetchProducts();
    prefetchShopData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const email = e.target.email.value;

    // Set loading status
    setStatus("Processing...");
    setStatusType("");

    fetch(`${API_URL}api/subscribe/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setStatus("Thank you for subscribing!");
          setStatusType("success");
          e.target.reset();
        } else {
          setStatus(
            "There was an error with your subscription. Please try again."
          );
          setStatusType("error");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setStatus("Something went wrong. Please try again later.");
        setStatusType("error");
      });
  };

  useEffect(() => {
    const carousel = document.querySelector(".business-carousel");
    const prevButton = document.querySelector(".carousel-prev");
    const nextButton = document.querySelector(".carousel-next");

    if (carousel && prevButton && nextButton) {
      const scrollAmount = 220; // Scroll width of one business card + gap

      prevButton.addEventListener("click", () => {
        carousel.scrollBy({
          left: -scrollAmount,
          behavior: "smooth",
        });
      });

      nextButton.addEventListener("click", () => {
        carousel.scrollBy({
          left: scrollAmount,
          behavior: "smooth",
        });
      });

      // Optional: Add auto-scroll feature
      let autoScrollInterval;

      const startAutoScroll = () => {
        autoScrollInterval = setInterval(() => {
          // Check if we've reached the end of the carousel
          if (
            carousel.scrollLeft + carousel.clientWidth >=
            carousel.scrollWidth - 10
          ) {
            // If at the end, scroll back to the beginning
            carousel.scrollTo({
              left: 0,
              behavior: "smooth",
            });
          } else {
            // Otherwise continue scrolling
            carousel.scrollBy({
              left: scrollAmount,
              behavior: "smooth",
            });
          }
        }, 5000); // Auto-scroll every 5 seconds
      };

      const stopAutoScroll = () => {
        clearInterval(autoScrollInterval);
      };

      // Start auto-scroll when page loads
      startAutoScroll();

      // Stop auto-scroll when user interacts with carousel
      carousel.addEventListener("mouseenter", stopAutoScroll);
      carousel.addEventListener("touchstart", stopAutoScroll);

      // Resume auto-scroll when user stops interacting
      carousel.addEventListener("mouseleave", startAutoScroll);
      carousel.addEventListener("touchend", startAutoScroll);

      // Clean up event listeners on component unmount
      return () => {
        prevButton.removeEventListener("click", () => {});
        nextButton.removeEventListener("click", () => {});
        carousel.removeEventListener("mouseenter", stopAutoScroll);
        carousel.removeEventListener("touchstart", stopAutoScroll);
        carousel.removeEventListener("mouseleave", startAutoScroll);
        carousel.removeEventListener("touchend", startAutoScroll);
        clearInterval(autoScrollInterval);
      };
    }
  }, [businesses]); // Dependency on businesses array so this runs after businesses are loaded

  return (
    <div className="home-container">
      {/* Banner Section */}
      {/* Product Gallery Section */}
      <div className="shipping-banner">
        <div className="banner-content">
          <span className="shipping-icon">🚚</span>
          <span className="banner-text">FREE SHIPPING on orders $75+</span>
          <span className="sparkle">✨</span>
        </div>
      </div>
      {/* Business Partners Section - Added before About Us */}
      <section id="business-partners" className="business-partners-section">
        <div className="container">
          <div className="section-heading">
            <h2>Shop By ur Favorite Small Eco-Business</h2>
          </div>

          {businessesLoading ? (
            <div className="loading">Loading Eco-businesses...</div>
          ) : businesses.length > 0 ? (
            <div className="business-carousel-container">
              <div className="business-carousel">
                {businesses.map((business) => (
                  <div key={business.id} className="business-card">
                    <a
                      href={`/businessproducts/${business.id}`}
                      title={business.name}
                    >
                      <div className="business-logo-container">
                        <img
                          src={business.logonew || "/placeholder-logo.jpg"}
                          alt={`${business.name} logo`}
                          className="business-logo"
                        />
                      </div>
                      <div className="business-name">{business.name}</div>
                    </a>
                  </div>
                ))}
              </div>

              {businesses.length > 4 && (
                <div className="carousel-controls">
                  <button className="carousel-control carousel-prev">
                    <span>&#10094;</span>
                  </button>
                  <button className="carousel-control carousel-next">
                    <span>&#10095;</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="no-businesses">
              <p>Our partner businesses will be displayed here soon!</p>
            </div>
          )}
        </div>
      </section>

        <div className="eco-curious-section">
        <div className="eco-curious-content">
          <div className="eco-curious-heading">
            <h2>Find the next big indie brand. Guaranteed sustainable.</h2>
          </div>
          <p className="eco-curious-description">
            ur verdure connects people to sustainable, ethical businesses that deserve to be seen: from family-run shops to one-woman brands making real change.
          </p>
          <Link to="/shop">
            <button className="eco-curious-button">Shop Now</button>
          </Link>{" "}
        </div>
        <img
          src={curiousBanner}
          alt="Eco-Curious Banner"
          className="eco-curious-banner"
          style={{ opacity: 0.2, filter: "contrast(0.9) saturate(0.6)" }}
        />
      </div>

      <section className="products-section">
        <div className="container">
          <div className="section-heading">
            <h2>Newly Added</h2>
          </div>
          <div className="product-gallery">
            {loading ? (
              <div className="loading">Loading products...</div>
            ) : products.length > 0 ? (
              <div className="product-grid">
                {products.map((product) => (
                  <div key={product.id} className="product-card">
                    {/* <a href={`https://verdurefrontendproj.vercel.app/shop/products/${product.id}`}> */}
                    <a
                      href={`https://urverdure.app/shop/products/${product.id}`}
                    >
                      <div className="product-image">
                        {/* Get first image from images array if it exists */}
                        <img
                          src={
                            product.images && product.images.length > 0
                              ? product.images[0].image
                              : "/placeholder-product.jpg"
                          }
                          alt={product.name}
                        />
                        <div className="product-hover">
                          <span>View Details</span>
                        </div>
                      </div>
                      <div className="product-details">
                        <h3 className="product-name">{product.name}</h3>
                        {/* <p className="product-brand">{product.business}</p> */}
                        <p className="product-price">${product.price}</p>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-products">
                <p>No products available at the moment. Check back soon!</p>
              </div>
            )}

            <div className="view-all-container">
              {/* <a href="https://verdurefrontendproj.vercel.app/shop" className="view-all-button">View All Products</a> */}
              <a href="https://urverdure.app/shop" className="view-all-button">
                View All Products
              </a>
            </div>
            <br></br>
            <br></br>
          </div>
        </div>
      </section>
      {/* Quiz Section (hidden for now)
      <section className="banner-section">
        <div className="banner-image-container">
          <img src={bannerImage} alt="VerdURe Banner" className="home-banner" />
          <div className="shop-now-container">
            <button className="shop-button">
              <Link to="/quiz" id="takeQuizText">
                Take the Quiz
              </Link>
            </button>
          </div>
        </div>
      </section> */}
      <main>{children}</main>
      {/* About Us Section */}
      {/* <section id="about" className="about-section">
        <div className="container">
          
          <div className="section-heading">
      <h2>About Us.</h2>
    </div>
    <div className="about-content">
      <p>
        Verdure is a digital marketplace built to make sustainable shopping more accessible, relatable, and transparent. If you've ever wanted to shop more eco-friendly but felt overwhelmed by the options—or found them too expensive or hard to connect with—we’re here to change that.
      </p>
      <p>
        We curate ethical and sustainable brands on one convenient platform, especially for people starting their environmental journey. From clothing and cosmetics to home goods and learning resources, every item is chosen with care to meet real lifestyle needs without compromising on quality or style.
      </p>
      <p>
        Our goal is to support ethical businesses and make sustainability feel less intimidating and more approachable for younger audiences who want to shop in line with their values.
      </p>
      <p>
        Every brand featured on Verdure is vetted by our team and sustainability-focused student organizations for ethical practices, transparent sourcing, and real impact. You’ll find clear details on each business page—so you can shop with confidence and purpose.
      </p>
    </div>
          
        </div>
      </section> */}
      {/* <div className="eco-curious-section">
        <div className="eco-curious-content">
          <div className="eco-curious-heading">
            <h2>Find the next big indie brand. Guaranteed sustainable.</h2>
          </div>
          <p className="eco-curious-description">
            Verdure is designed for the eco-curious, not just the eco-commited.
            Explore up-and-coming brands and what they stand for.
          </p>
          <Link to="/shop">
            <button className="eco-curious-button">Shop Now</button>
          </Link>{" "}
        </div>
        <img
          src={curiousBanner}
          alt="Eco-Curious Banner"
          className="eco-curious-banner"
          style={{ opacity: 0.6, filter: "contrast(0.9)" }}
        />
      </div> */}
      {/* Sustainability Verification Section */}
      <section id="sustainability" className="sustainability-section">
        <div className="container">
          <div className="section-heading">
            <h2>Verdure's Sustainability Standards</h2>
          </div>
          <div className="sustainability-content">
            <p>
              We verify all products through our rigorous application process
              that evaluates sourcing methods, materials used, manufacturing
              practices, and overall environmental impact.
            </p>
            <p>
              Every business we partner with must demonstrate their commitment
              to ethical practices, fair labor, and reducing ecological
              footprints throughout their supply chain.
            </p>
            <div className="sustainability-icons">
              <div className="icon-item">
                <div className="icon">🌱</div>
                <span>Eco-Friendly Materials</span>
              </div>
              <div className="icon-item">
                <div className="icon">♻️</div>
                <span>Reduced Waste</span>
              </div>
              <div className="icon-item">
                <div className="icon">👥</div>
                <span>Fair Labor</span>
              </div>
              <div className="icon-item">
                <div className="icon">🏭</div>
                <span>Lower Carbon Footprint</span>
              </div>
            </div>
            <div className="learn-more-container">
              <a
                href="https://urverdure.app/sustainability"
                className="learn-more-button"
              >
                Learn More About Our Process
              </a>
              {/* <a href="https://verdurefrontendproj.vercel.app/sustainability" className="learn-more-button">Learn More About Our Process</a> */}
            </div>
          </div>
        </div>
      </section>
      <section
        className="subscribe-section"
        style={{
          backgroundColor: "white",
          padding: "4rem 2rem",
          color: "green",
          borderRadius: "8px",
          marginBottom: "3rem",
          boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          className="subscribe-container"
          style={{
            maxWidth: "900px",
            margin: "0 auto",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "2.2rem",
              marginBottom: "1rem",
              fontWeight: "600",
            }}
          >
            Join Our Sustainable Community
          </h2>

          <p
            style={{
              fontSize: "1.1rem",
              marginBottom: "2rem",
              opacity: "0.9",
              maxWidth: "700px",
              margin: "0 auto 2rem",
            }}
          >
            Stay updated with our latest eco-friendly products, sustainability
            tips, and exclusive offers.
          </p>

          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              maxWidth: "550px",
              margin: "0 auto",
              gap: "1rem",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "1rem",
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                required
                style={{
                  flex: "1",
                  padding: "0.8rem 1.2rem",
                  fontSize: "1rem",
                  borderRadius: "4px",
                  border: "none",
                  outline: "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
              <button
                id="home-subscribe-button"
                type="submit"
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  borderRadius: "10px",
                  // padding: "0 1rem",
                  fontSize: "1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => (
                  (e.currentTarget.style.backgroundColor = "#388E3C"),
                  (e.currentTarget.style.cursor =
                    "url('shrok100.svg') 32 32, auto")
                )}
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#4CAF50")
                }
              >
                Subscribe
              </button>
            </div>

            {status && (
              <div
                style={{
                  padding: "0.5rem",
                  marginTop: "0.5rem",
                  color:
                    statusType === "success"
                      ? "#4CAF50"
                      : statusType === "error"
                      ? "#f44336"
                      : "#757575",
                  fontSize: "0.95rem",
                }}
              >
                {status}
              </div>
            )}
          </form>

          <p
            style={{
              fontSize: "0.9rem",
              marginTop: "1.5rem",
              opacity: "0.7",
            }}
          >
            We respect your privacy and will never share your information.
          </p>
        </div>
      </section>
    </div>
  );
}

export default Home;
